import { supabase } from '../lib/supabase';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

/**
 * Register for an event and get a ticket
 */
export async function registerTicket({ eventSlug, lastName, email, adults, children }) {
  const response = await fetch(`${SUPABASE_URL}/functions/v1/register-ticket`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'apikey': SUPABASE_PUBLISHABLE_KEY,
      'Authorization': `Bearer ${SUPABASE_PUBLISHABLE_KEY}`,
    },
    body: JSON.stringify({
      eventSlug,
      lastName,
      email,
      adults,
      children,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw {
      status: response.status,
      error: data.error,
      message: data.message,
    };
  }

  return data;
}

/**
 * Get current capacity for an event
 */
export async function getEventCapacity(eventSlug) {
  const { data, error } = await supabase.rpc('get_event_capacity', {
    p_event_slug: eventSlug,
  });

  if (error) {
    console.error('Error fetching capacity:', error);
    return null;
  }

  if (data && data.length > 0) {
    return {
      currentCount: data[0].current_count,
      maxCapacity: data[0].max_capacity,
      isAtCapacity: data[0].is_at_capacity,
    };
  }

  return null;
}

/**
 * Subscribe to real-time capacity updates
 */
export function subscribeToCapacity(eventSlug, onUpdate) {
  // First get event ID for the subscription
  const channel = supabase
    .channel('registrations-changes')
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'registrations',
      },
      async () => {
        // When any registration changes, fetch updated capacity
        const capacity = await getEventCapacity(eventSlug);
        if (capacity) {
          onUpdate(capacity);
        }
      }
    )
    .subscribe();

  return () => {
    supabase.removeChannel(channel);
  };
}
